import { createSystem, defaultConfig } from "@chakra-ui/react";

import { globalCss } from "./global-css";
import { badgeRecipe } from "./recipes/badge";
import { buttonRecipe } from "./recipes/button";
import { fieldRecipe } from "./recipes/field";
import { iconRecipe } from "./recipes/icon";
import { linkRecipe } from "./recipes/link";
import { semanticTokens } from "./semantic-tokens";
import { dialogSlotRecipe } from "./slot-recipes/dialog";
import { selectSlotRecipe } from "./slot-recipes/select";
import { tabsSlotRecipe } from "./slot-recipes/tabs";
import { toastSlotRecipe } from "./slot-recipes/toast";
import { textStyles } from "./text-styles";
import { tokens } from "./tokens";

export const system = createSystem(defaultConfig, {
  globalCss,
  theme: {
    breakpoints: {
      "2xl": "1536px",
      desktop: "1024px",
      lg: "1024px",
      md: "520px",
      mobile: "320px",
      sm: "320px",
      xl: "1280px",
    },
    recipes: {
      badge: badgeRecipe,
      button: buttonRecipe,
      icon: iconRecipe,
      link: linkRecipe,
    },
    semanticTokens: {
      ...semanticTokens,
      letterSpacings: {
        none: {
          value: "0%",
        },
      },
    },
    slotRecipes: {
      dialog: dialogSlotRecipe,
      field: fieldRecipe,
      select: selectSlotRecipe,
      tabs: tabsSlotRecipe,
      toast: toastSlotRecipe,
    },
    textStyles,
    tokens,
  },
});
